import i18n from "@/language/i18n";

export default {
    props: {
        onlyPersons: { type: Boolean, default: undefined },
        headers: { type: Array },
        mandatoryFilters: undefined,
        filterPreset: { type: Object },
        path: { type: String, default: 'contacts' },
        resultPageSize: { type: Number, default: 50 },
        showIsEmployeeFilter: { type: Boolean, default: true },
        showCompanyFilter: { type: Boolean, default: true },
        withSelection: { type: Boolean, default: false},
        selection: { type: [Array, Object], default: () => [] },
        responseDialogData: { type: Function, default: undefined },
        excludeIds: { type: Array, required: false },
        addUniqueIdentifier: { type: Boolean, default: false},
        dialogTitle: { type: String, default: i18n.t('Common.person') },
        isCompanyPicker: { type: Boolean, default: false},
        isPrivateContactPicker: {type: Boolean, default: false},
        showContactTypeFilter: { type: Boolean, default: false},
        checkSelectedItemsLength: { type: Boolean, default: false },
    },
}
